import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import './../../semafone/jquery.ba-postmessage.js';
import './../../semafone/semafone-ecommerce-feedback.js';
import './../../semafone/semafone-ecommerce-min.js';
import './../../semafone/jquery-migrate-1.2.1.min.js';
import './../../semafone/rogers-to-semafone-ecommercejs.js';

import MyAccount from './MyAccount';

const ErrorFallback = () => {
    setTimeout(() => {
        window.location.href = '/pages/signin';
    }, 2000);
    return (
        <div className="seller">
            <div className="seller__error">
                <h2 className="" style={{ fontSize: '14px' }}>
                    Unable to access your account, please sign in again.
                </h2>
            </div>
        </div>
    );
};

const MyAccountApp = () => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: 1000 * 30, //30 seconds
            },
        },
    });

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <QueryClientProvider client={client}>
                <ReactQueryDevtools initialIsOpen={false} />
                <MyAccount />
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

const element = document.getElementById('myaccount-app') as HTMLElement;
const root = ReactDOM.createRoot(element);

if (element) {
    root.render(
        <React.StrictMode>
            <MyAccountApp />
        </React.StrictMode>,
    );
}
